/**
 *
 * Asynchronously loads the component for NotificationPage
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const NotificationPage = lazyLoad(
    () => import('./NotificationPage'),
    module => module.default,
);
